import React, {useEffect, useState} from "react";
import './Notifications.css'
import axios from "axios";
import Notifmessage from "./Notifmessage";
import {useMediaQuery} from "beautiful-react-hooks";



const BASEURL = 'https://api.sinatether.com/Auth/message/';






export default function (){


    const  [title,settitle] = useState('')
    const  [message,setmessage] = useState([])
    const  [count ,setcount] = useState(0)

    let phone = sessionStorage.getItem('user')
    let token = localStorage.getItem('TOKEN')
    const isSmall = useMediaQuery('(max-width: 768px)')





    useEffect(()=>{
        axios.get(BASEURL,{
            params:{
              phone : phone
            },
            withCredentials:true
        }).then((response)=>{
            console.log(response.data['message'])
            setmessage(response.data['message'])
        }).catch((error)=>{
            if (error){
                
            }
        })
    },[])





//                    <img src="https://img.icons8.com/ios/40/000000/appointment-reminders--v1.png"/>


    return(
    <div className="icons">
        <div className="notification">
            {isSmall ? 
            <a href="#">
                <div className="notBtn" href="#">
                    <div className="number">{ count == 0 ?'': count}</div>

                

                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 11.716 14.833">
  <g id="notif" transform="translate(-0.168 -0.833)">
    <path id="Path_15" data-name="Path 15" d="M5.4.833a3.763,3.763,0,0,0-3.734,4.23l.053.423a1.934,1.934,0,0,1-.607,1.661,2.934,2.934,0,0,0-.65,3.437l.069.142A3.147,3.147,0,0,0,3.362,12.5H8.843a3.041,3.041,0,0,0,2.07-5.27L10.883,7.2a2.09,2.09,0,0,1-.651-1.79l.043-.345A3.767,3.767,0,0,0,6.537.833ZM2.659,4.94A2.763,2.763,0,0,1,5.4,1.833H6.537A2.767,2.767,0,0,1,9.283,4.944l-.043.345A3.089,3.089,0,0,0,10.2,7.936l.029.027A2.041,2.041,0,0,1,8.843,11.5H3.362a2.147,2.147,0,0,1-1.931-1.21l-.069-.142a1.934,1.934,0,0,1,.429-2.265,2.934,2.934,0,0,0,.922-2.52Z" fill="#2d264b" fill-rule="evenodd"/>
    <path id="Path_16" data-name="Path 16" d="M4.524,13.7a.5.5,0,0,0-.8.6l.2.267a2.75,2.75,0,0,0,4.4,0l.2-.267a.5.5,0,1,0-.8-.6l-.2.267a1.75,1.75,0,0,1-2.8,0Z" fill="#2d264b"/>
  </g>
</svg>
                                    <div className="box">
                        <div className={'w-100 p-6  text-center rounded bgtowset text-white '}>
                            <h5 className={'text-large'}>اعلان ها</h5>


                        </div>
                        <div className="display">

                            <div className="cont">
                                {message ?

                              message.map((mess)=>{
                                  <Notifmessage message={message} setcount={setcount} c={count} />
                              })

                              :
                              <></>


                            }





                            </div>
                        </div>
                    </div>
                </div>
            </a>

            :

            <></>

                        }
        </div>
</div>

    )
}